/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_ProjectVisibilitySettings {
    Private = 10,
    Public = 20,
    ContactPerson = 30,
}
